// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LayersInner } from "./LayersInner";
import {
  LayersInnerFromJSON,
  LayersInnerFromJSONTyped,
  LayersInnerToJSON,
  LayersInnerToJSONTyped,
} from "./LayersInner";
import type { LayerInput } from "./LayerInput";
import {
  LayerInputFromJSON,
  LayerInputFromJSONTyped,
  LayerInputToJSON,
  LayerInputToJSONTyped,
} from "./LayerInput";

/**
 *
 * @export
 * @interface MapCreate
 */
export interface MapCreate {
  /**
   * Semantic ID to link comments across versions. This will be automatically set if not provided.
   */
  mapId?: number | null;
  /**
   *
   */
  name: string;
  /**
   *
   */
  layers?: Array<LayersInner>;
  /**
   *
   */
  studyArea?: LayerInput | null;
}

/**
 * Check if a given object implements the MapCreate interface.
 */
export function instanceOfMapCreate(value: object): value is MapCreate {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function MapCreateFromJSON(json: any): MapCreate {
  return MapCreateFromJSONTyped(json, false);
}

export function MapCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapCreate {
  if (json == null) {
    return json;
  }
  return {
    mapId:
      json["map_id"] === undefined ? undefined : json["map_id"] === null ? null : json["map_id"],
    name: json["name"],
    layers:
      json["layers"] == null ? undefined : (json["layers"] as Array<any>).map(LayersInnerFromJSON),
    studyArea:
      json["study_area"] === undefined
        ? undefined
        : json["study_area"] === null
        ? null
        : LayerInputFromJSON(json["study_area"]),
  };
}

export function MapCreateToJSON(json: any): MapCreate {
  return MapCreateToJSONTyped(json, false);
}

export function MapCreateToJSONTyped(
  value?: MapCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    map_id: value["mapId"],
    name: value["name"],
    layers:
      value["layers"] == null ? undefined : (value["layers"] as Array<any>).map(LayersInnerToJSON),
    study_area: LayerInputToJSON(value["studyArea"]),
  };
}
